import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withModifiers as _withModifiers, normalizeStyle as _normalizeStyle, vModelCheckbox as _vModelCheckbox, createVNode as _createVNode, createCommentVNode as _createCommentVNode, vModelSelect as _vModelSelect } from "vue"
import _imports_0 from '@/assets/gold-logo-transparent.png'


const _hoisted_1 = { class: "min-h-screen bg-black-primary text-white p-6" }
const _hoisted_2 = { class: "max-w-7xl mx-auto" }
const _hoisted_3 = { class: "flex gap-2 mb-6" }
const _hoisted_4 = {
  key: 0,
  class: "grid grid-cols-1 lg:grid-cols-3 gap-4"
}
const _hoisted_5 = { class: "lg:col-span-1 bg-black-secondary rounded-2xl border border-zinc-800" }
const _hoisted_6 = { class: "p-3 border-b border-zinc-800" }
const _hoisted_7 = { class: "p-2 max-h-[70vh] overflow-auto" }
const _hoisted_8 = ["onClick"]
const _hoisted_9 = { class: "flex items-center justify-between" }
const _hoisted_10 = { class: "font-semibold truncate" }
const _hoisted_11 = ["onClick"]
const _hoisted_12 = ["innerHTML"]
const _hoisted_13 = { class: "flex flex-wrap gap-1 mt-2" }
const _hoisted_14 = { class: "lg:col-span-2 bg-black-secondary rounded-2xl border border-zinc-800 p-4" }
const _hoisted_15 = { class: "grid grid-cols-1 md:grid-cols-6 gap-3 mb-3" }
const _hoisted_16 = { class: "flex items-center gap-2" }
const _hoisted_17 = { class: "mt-3 flex items-center justify-end gap-2" }
const _hoisted_18 = ["disabled"]
const _hoisted_19 = {
  key: 1,
  class: "bg-black-secondary rounded-2xl p-4 border border-zinc-800 mb-6"
}
const _hoisted_20 = { class: "grid grid-cols-1 md:grid-cols-3 gap-4 mt-6" }
const _hoisted_21 = ["onDragover", "onDrop"]
const _hoisted_22 = { class: "flex items-center justify-between mb-2" }
const _hoisted_23 = { class: "text-lg font-semibold text-gold-primary" }
const _hoisted_24 = { class: "text-xs text-gray-400" }
const _hoisted_25 = { class: "space-y-3 min-h-[80px]" }
const _hoisted_26 = ["onDragstart", "onClick"]
const _hoisted_27 = { class: "flex items-start justify-between gap-3" }
const _hoisted_28 = { class: "font-semibold" }
const _hoisted_29 = {
  key: 0,
  class: "text-sm text-gray-400 line-clamp-3"
}
const _hoisted_30 = { class: "flex flex-wrap gap-1 mt-2" }
const _hoisted_31 = { class: "mt-2 text-xs text-gray-500 flex items-center justify-between" }
const _hoisted_32 = {
  key: 0,
  class: "mr-2"
}
const _hoisted_33 = { key: 1 }
const _hoisted_34 = { class: "flex gap-2" }
const _hoisted_35 = ["onClick"]
const _hoisted_36 = ["onClick"]
const _hoisted_37 = { class: "grid grid-cols-2 gap-2 max-h-40 overflow-auto" }
const _hoisted_38 = ["checked", "onChange"]
const _hoisted_39 = { class: "inline-flex items-center justify-center rounded-full border border-zinc-700 bg-black-primary text-[10px] h-6 w-7 text-gold-primary" }
const _hoisted_40 = { class: "text-sm text-zinc-200" }
const _hoisted_41 = { class: "mt-3 flex justify-end gap-2" }
const _hoisted_42 = ["onClick"]
const _hoisted_43 = {
  key: 0,
  class: "text-sm text-gray-400"
}
const _hoisted_44 = { key: 1 }
const _hoisted_45 = {
  key: 0,
  class: "text-sm text-gray-500"
}
const _hoisted_46 = {
  key: 1,
  class: "space-y-2"
}
const _hoisted_47 = { class: "text-gray-300" }
const _hoisted_48 = { class: "text-xs text-gray-500" }
const _hoisted_49 = { class: "mt-2 flex gap-2" }
const _hoisted_50 = ["onClick"]
const _hoisted_51 = {
  key: 2,
  class: "bg-black-secondary rounded-2xl p-2 border border-zinc-800"
}
const _hoisted_52 = {
  key: 3,
  class: "fixed inset-0 z-50 flex items-center justify-center"
}
const _hoisted_53 = { class: "relative z-10 w-full max-w-2xl bg-black-secondary border border-zinc-800 rounded-2xl shadow-xl" }
const _hoisted_54 = { class: "p-4 space-y-3" }
const _hoisted_55 = { class: "grid grid-cols-1 md:grid-cols-3 gap-3" }
const _hoisted_56 = {
  key: 0,
  class: "text-sm text-red-400 border border-red-900/40 bg-red-900/10 rounded-lg px-3 py-2"
}
const _hoisted_57 = { class: "flex justify-end" }
const _hoisted_58 = ["disabled"]
const _hoisted_59 = {
  key: 4,
  class: "fixed inset-0 z-50 flex items-center justify-center"
}
const _hoisted_60 = { class: "relative z-10 w-full max-w-3xl bg-black-secondary border border-zinc-800 rounded-2xl shadow-xl" }
const _hoisted_61 = { class: "p-4 border-b border-zinc-800 flex items-center justify-between" }
const _hoisted_62 = { class: "text-2xl font-semibold text-gold-primary" }
const _hoisted_63 = { class: "p-4 grid grid-cols-1 md:grid-cols-3 gap-4" }
const _hoisted_64 = { class: "md:col-span-2 space-y-3" }
const _hoisted_65 = { class: "bg-black-primary/70 rounded-xl border border-zinc-700 p-4" }
const _hoisted_66 = { class: "text-sm text-zinc-200 whitespace-pre-line" }
const _hoisted_67 = { class: "bg-black-primary/70 rounded-xl border border-zinc-700 p-3" }
const _hoisted_68 = {
  key: 0,
  class: "text-sm text-gray-400"
}
const _hoisted_69 = { key: 1 }
const _hoisted_70 = {
  key: 0,
  class: "text-sm text-gray-500"
}
const _hoisted_71 = {
  key: 1,
  class: "space-y-2"
}
const _hoisted_72 = { class: "text-gray-300" }
const _hoisted_73 = { class: "text-xs text-gray-500" }
const _hoisted_74 = { class: "mt-2 flex gap-2" }
const _hoisted_75 = { class: "space-y-3" }
const _hoisted_76 = { class: "bg-black-primary/70 rounded-xl border border-zinc-700 p-4" }
const _hoisted_77 = { class: "text-sm text-zinc-200" }
const _hoisted_78 = { class: "bg-black-primary/70 rounded-xl border border-zinc-700 p-4" }
const _hoisted_79 = { class: "text-sm text-zinc-200" }
const _hoisted_80 = { class: "bg-black-primary/70 rounded-xl border border-zinc-700 p-4" }
const _hoisted_81 = { class: "text-sm text-zinc-200" }
const _hoisted_82 = { class: "bg-black-primary/70 rounded-xl border border-zinc-700 p-4" }
const _hoisted_83 = { class: "mt-1 flex flex-wrap gap-1" }

import {
  onMounted, onUnmounted, ref, computed, watch,
} from 'vue';
import { auth } from '@/config/firebase';
import WorkspaceService from '@/service/workspace.service';
import type {
  WorkspaceItem,
  WorkspaceItemType,
  WorkspaceStatus,
  WorkspacePriority,
  NewWorkspaceItem,
} from '@/types/workspace';
import NoteEditor from '@/components/NoteEditor.vue';
import UserService from '@/service/user.service';
import KPIsDashboard from '@/views/AdminPanel/KPIsDashboard.vue';

type Unsubscribe = () => void;
type FireDate = Date | { seconds: number };
type TeamMember = {
  id: string;
  fullName?: string;
  email?: string;
  userId?: string;
  roles?: string[];
};


export default /*@__PURE__*/_defineComponent({
  __name: 'WorkspaceView',
  setup(__props) {

const allItems = ref<WorkspaceItem[]>([]);
const tab = ref<'task' | 'idea' | 'kpi'>('task');
const unsubscribe = ref<Unsubscribe | null>(null);

// Notes UX state
const ideaSearch = ref('');
const selectedIdeaId = ref<string | null>(null);
const ideaEditor = ref('');
const ideaTitle = ref('');
const ideaLabels = ref<string>('');
const ideaPinned = ref(false);
const ideaColor = ref('#0C0C0C');

// legacy quick-add model (unused, replaced by modal) kept for potential future use
// const taskTitle = ref('');
// const taskDescription = ref('');
// const taskPriority = ref<WorkspacePriority>('Medium');
// const taskLabels = ref<string>('');
// const taskDueDate = ref<string>('');

// Team members for assignment
const teamMembers = ref<TeamMember[]>([]);
const assignOpenFor = ref<string | null>(null);
const assigneesSelection = ref<Record<string, Set<string>>>({});

const statusesByType: Record<WorkspaceItemType, WorkspaceStatus[]> = {
  idea: ['New', 'Prioritized', 'In Progress', 'Launched'],
  task: ['Backlog', 'In Progress', 'Done'],
};

const statuses = computed(() => {
  if (tab.value === 'task' || tab.value === 'idea') {
    return statusesByType[tab.value as 'task' | 'idea'];
  }
  return [] as WorkspaceStatus[];
});

const itemsByStatus = computed<Record<string, WorkspaceItem[]>>(() => {
  const grouped: Record<string, WorkspaceItem[]> = {};
  statuses.value.forEach((s) => {
    grouped[s] = [];
  });
  allItems.value
    .filter((x) => x.type === tab.value)
    .forEach((item) => {
      if (!grouped[item.status]) grouped[item.status] = [];
      grouped[item.status].push(item);
    });
  return grouped;
});

const ideaItems = computed(() => allItems.value.filter((x) => x.type === 'idea'));
const filteredIdeas = computed(() => {
  const q = ideaSearch.value.trim().toLowerCase();
  const items = [...ideaItems.value].sort(
    (a, b) => Number(b.pinned) - Number(a.pinned),
  );
  if (!q) return items;
  return items.filter((i) => {
    const haystack = [
      i.title || '',
      i.description || '',
      (i.labels || []).join(','),
      i.contentHtml || '',
    ].join(' ');
    return haystack.toLowerCase().includes(q);
  });
});

const selectedIdea = computed(
  () => ideaItems.value.find((i) => i.id === selectedIdeaId.value) || null,
);

watch(selectedIdea, (val) => {
  ideaEditor.value = val?.contentHtml || '';
  ideaTitle.value = val?.title || '';
  ideaLabels.value = (val?.labels || []).join(', ');
  ideaPinned.value = !!val?.pinned;
  ideaColor.value = val?.color || '#0C0C0C';
});

function stopSubscription() {
  if (unsubscribe.value) {
    unsubscribe.value();
    unsubscribe.value = null;
  }
}

function startSubscription() {
  stopSubscription();
  unsubscribe.value = WorkspaceService.subscribeItems((items) => {
    allItems.value = items;
  });
}

onMounted(() => {
  startSubscription();
});
onUnmounted(() => {
  stopSubscription();
});
// Fetch team
onMounted(async () => {
  try {
    teamMembers.value = await UserService.getTeamMembers();
  } catch (e) {
    // noop
  }
});
function parseLabels(input: string): string[] | undefined {
  const parts = input
    .split(',')
    .map((x) => x.trim())
    .filter(Boolean);
  return parts.length ? parts : undefined;
}

async function addIdea() {
  const payload: NewWorkspaceItem = {
    type: 'idea',
    title: (ideaTitle.value || 'Untitled').trim(),
    contentHtml: ideaEditor.value,
    status: 'New',
    labels: parseLabels(ideaLabels.value),
    createdBy: auth.currentUser?.email || 'unknown',
    pinned: ideaPinned.value,
    color: ideaColor.value,
  };
  const id = await WorkspaceService.addItem(payload);
  selectedIdeaId.value = id;
}

async function saveCurrentIdea() {
  if (!selectedIdea.value) return;
  await WorkspaceService.updateItem(selectedIdea.value.id, {
    title: (ideaTitle.value || 'Untitled').trim(),
    contentHtml: ideaEditor.value,
    labels: parseLabels(ideaLabels.value),
    pinned: ideaPinned.value,
    color: ideaColor.value,
  });
}

async function togglePin(idea: WorkspaceItem) {
  await WorkspaceService.updateItem(idea.id, { pinned: !idea.pinned });
}

async function duplicateIdea(idea: WorkspaceItem) {
  const copy: NewWorkspaceItem = {
    type: 'idea',
    title: `${idea.title} (copy)`,
    contentHtml: idea.contentHtml,
    description: idea.description,
    status: idea.status,
    labels: idea.labels,
    createdBy: auth.currentUser?.email || 'unknown',
    pinned: false,
    color: idea.color,
  };
  const id = await WorkspaceService.addItem(copy);
  selectedIdeaId.value = id;
}

// Legacy quick-add kept for reference; modal flow replaces it
// async function addTask() {
//   const payload: NewWorkspaceItem = {
//     type: 'task',
//     title: taskTitle.value.trim(),
//     description: taskDescription.value.trim(),
//     status: 'Backlog',
//     priority: taskPriority.value,
//     labels: parseLabels(taskLabels.value),
//     dueDate: taskDueDate.value ? (new Date(taskDueDate.value) as Date) : undefined,
//     createdBy: auth.currentUser?.email || 'unknown',
//   };
//   if (!payload.title) return;
//   await WorkspaceService.addItem(payload);
//   taskTitle.value = '';
//   taskDescription.value = '';
//   taskLabels.value = '';
//   taskDueDate.value = '';
// }

// manual move removed in favor of drag and drop

// Drag & Drop for tasks
const dragItemId = ref<string | null>(null);
const dragOverStatus = ref<WorkspaceStatus | null>(null);

function onDragStart(item: WorkspaceItem) {
  dragItemId.value = item.id;
}

function onDragOver(status: WorkspaceStatus) {
  dragOverStatus.value = status;
}

async function onDrop(status: WorkspaceStatus) {
  const currentDraggedId = dragItemId.value;
  dragOverStatus.value = null;
  dragItemId.value = null;
  if (!currentDraggedId) return;
  const item = allItems.value.find((x) => x.id === currentDraggedId);
  if (!item || item.type !== 'task' || item.status === status) return;
  await WorkspaceService.updateItem(item.id, { status });
}

function initialsOf(member: TeamMember): string {
  const src = (member.fullName && member.fullName.trim()) || member.email || '';
  if (!src) return '—';
  const parts = src.split(/\s|\.|@/).filter(Boolean);
  const first = parts[0]?.[0] || '';
  const second = parts.length > 1 ? parts[1]?.[0] : '';
  return (first + second).toUpperCase();
}

function initialsOfAssignee(a: { fullName?: string; email?: string }): string {
  const src = (a.fullName && a.fullName.trim()) || a.email || '';
  if (!src) return '—';
  const parts = src.split(/\s|\.|@/).filter(Boolean);
  const first = parts[0]?.[0] || '';
  const second = parts.length > 1 ? parts[1]?.[0] : '';
  return (first + second).toUpperCase();
}

function openAssign(item: WorkspaceItem) {
  assignOpenFor.value = item.id;
  const key = item.id;
  const emails = (item.assignees || [])
    .map((a: { email?: string }) => a.email)
    .filter(Boolean) as string[];
  assigneesSelection.value[key] = new Set<string>(emails);
}

function toggleAssignee(itemId: string, email: string) {
  const set = assigneesSelection.value[itemId] || new Set<string>();
  if (set.has(email)) set.delete(email);
  else set.add(email);
  assigneesSelection.value[itemId] = set;
}

async function saveAssignees(item: WorkspaceItem) {
  const key = item.id;
  const emails = Array.from(assigneesSelection.value[key] || new Set<string>());
  const selected = teamMembers.value
    .filter((m) => emails.includes(m.email || ''))
    .map((m) => ({
      userId: m.userId || m.id,
      fullName: m.fullName,
      email: m.email,
    }));
  await WorkspaceService.updateItem(item.id, { assignees: selected });
  assignOpenFor.value = null;
}

function cancelAssign() {
  assignOpenFor.value = null;
}

const commentsOpenFor = ref<string | null>(null);
const commentsLoading = ref(false);
const comments = ref<
  { id: string; author?: string; message: string; createdAt?: FireDate }[]
>([]);
const newComment = ref('');

// Ticket detail modal state
const showTicketModal = ref(false);
const activeTicket = ref<WorkspaceItem | null>(null);
const activeTicketComments = ref<
  { id: string; author?: string; message: string; createdAt?: FireDate }[]
>([]);
const activeTicketCommentsLoading = ref(false);
const newTicketComment = ref('');

async function toggleComments(itemId: string) {
  if (commentsOpenFor.value === itemId) {
    commentsOpenFor.value = null;
    comments.value = [];
    return;
  }
  commentsOpenFor.value = itemId;
  commentsLoading.value = true;
  comments.value = await WorkspaceService.getComments(itemId);
  commentsLoading.value = false;
}

async function submitComment(itemId: string) {
  const message = newComment.value.trim();
  if (!message) return;
  await WorkspaceService.addComment(itemId, {
    author: auth.currentUser?.email || 'unknown',
    message,
  });
  newComment.value = '';
  // reload
  comments.value = await WorkspaceService.getComments(itemId);
}

// delete handled elsewhere (removed to satisfy linter)

function formatDate(date: FireDate | undefined) {
  try {
    if (!date) return '—';
    const asAny = date as unknown as { seconds?: number };
    const d = asAny && typeof asAny.seconds === 'number'
      ? new Date(asAny.seconds * 1000)
      : new Date(date as Date);
    return d.toLocaleDateString();
  } catch {
    return '—';
  }
}

// Ticket detail modal
async function openTicket(item: WorkspaceItem) {
  if (item.type !== 'task') return;
  activeTicket.value = item;
  showTicketModal.value = true;
  activeTicketCommentsLoading.value = true;
  activeTicketComments.value = await WorkspaceService.getComments(item.id);
  activeTicketCommentsLoading.value = false;
}

function closeTicket() {
  showTicketModal.value = false;
  activeTicket.value = null;
  activeTicketComments.value = [];
  newTicketComment.value = '';
}

async function submitTicketComment() {
  if (!activeTicket.value) return;
  const message = newTicketComment.value.trim();
  if (!message) return;
  await WorkspaceService.addComment(activeTicket.value.id, {
    author: auth.currentUser?.email || 'unknown',
    message,
  });
  newTicketComment.value = '';
  activeTicketComments.value = await WorkspaceService.getComments(
    activeTicket.value.id,
  );
}

// New Task Modal (liquid glass)
const showAddTaskModal = ref(false);
const newTaskTitle = ref('');
const newTaskDescription = ref('');
const newTaskPriority = ref<WorkspacePriority>('Medium');
const newTaskDueDate = ref<string>('');
const newTaskLabels = ref<string>('');
const newTaskError = ref<string>('');
const isCreatingTask = ref(false);

function openNewTaskModal() {
  newTaskTitle.value = '';
  newTaskDescription.value = '';
  newTaskPriority.value = 'Medium';
  newTaskDueDate.value = '';
  newTaskLabels.value = '';
  newTaskError.value = '';
  showAddTaskModal.value = true;
}

function closeNewTaskModal() {
  showAddTaskModal.value = false;
}

async function submitNewTask() {
  newTaskError.value = '';
  const title = newTaskTitle.value.trim();
  if (!title) {
    newTaskError.value = 'Please enter a clear, actionable task title.';
    return;
  }
  isCreatingTask.value = true;
  try {
    const payload: NewWorkspaceItem = {
      type: 'task',
      title,
      description: newTaskDescription.value.trim(),
      status: 'Backlog',
      priority: newTaskPriority.value,
      labels: parseLabels(newTaskLabels.value),
      dueDate: newTaskDueDate.value ? (new Date(newTaskDueDate.value) as Date) : undefined,
      createdBy: auth.currentUser?.email || 'unknown',
    };
    await WorkspaceService.addItem(payload);
    showAddTaskModal.value = false;
  } catch (e: unknown) {
    let msg = 'Something went wrong while creating the task.';
    if (typeof e === 'object' && e !== null) {
      const anyErr = e as { message?: string; code?: string };
      msg = anyErr.message || anyErr.code || msg;
    }
    newTaskError.value = `Could not create task. ${msg}`;
  } finally {
    isCreatingTask.value = false;
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[34] || (_cache[34] = _createElementVNode("div", { class: "flex items-center justify-between mb-6" }, [
        _createElementVNode("div", null, [
          _createElementVNode("h1", { class: "text-3xl md:text-4xl font-bold text-gold-primary" }, " TALAB Workspace "),
          _createElementVNode("p", { class: "text-gray-300" }, " Ideas, planning and delivery in one place. ")
        ]),
        _createElementVNode("img", {
          src: _imports_0,
          alt: "TALAB",
          class: "w-20"
        })
      ], -1)),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("button", {
          class: _normalizeClass(["px-4 py-2 rounded-lg border", tab.value === 'task' ? 'bg-gold-primary text-black border-gold-secondary' : 'bg-black-secondary text-gold-primary border-zinc-700']),
          onClick: _cache[0] || (_cache[0] = ($event: any) => (tab.value = 'task'))
        }, "Tasks", 2),
        _createElementVNode("button", {
          class: _normalizeClass(["px-4 py-2 rounded-lg border", tab.value === 'idea' ? 'bg-gold-primary text-black border-gold-secondary' : 'bg-black-secondary text-gold-primary border-zinc-700']),
          onClick: _cache[1] || (_cache[1] = ($event: any) => (tab.value = 'idea'))
        }, "Ideas", 2),
        _createElementVNode("button", {
          class: _normalizeClass(["px-4 py-2 rounded-lg border", tab.value === 'kpi' ? 'bg-gold-primary text-black border-gold-secondary' : 'bg-black-secondary text-gold-primary border-zinc-700']),
          onClick: _cache[2] || (_cache[2] = ($event: any) => (tab.value = 'kpi'))
        }, "KPIs", 2)
      ]),
      (tab.value === 'idea')
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((ideaSearch).value = $event)),
                  placeholder: "Search ideas…",
                  class: "w-full px-3 py-2 rounded bg-black-primary border border-zinc-700 placeholder:text-zinc-500"
                }, null, 512), [
                  [_vModelText, ideaSearch.value]
                ])
              ]),
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("button", {
                  onClick: _cache[4] || (_cache[4] = ($event: any) => {
                selectedIdeaId.value = null;
                ideaEditor.value = '';
                ideaTitle.value = '';
                ideaLabels.value = '';
                ideaPinned.value = false;
                ideaColor.value = '#0C0C0C';
              }),
                  class: "w-full mb-2 px-3 py-2 rounded bg-gold-primary text-black hover:bg-gold-secondary"
                }, " + New note "),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredIdeas.value, (idea) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: idea.id,
                    onClick: ($event: any) => (selectedIdeaId.value = idea.id),
                    class: _normalizeClass(["p-3 rounded-xl border mb-2 cursor-pointer", 
                selectedIdeaId.value === idea.id
                  ? 'border-gold-primary bg-black-primary'
                  : 'border-zinc-800 bg-black-primary/60'
              ]),
                    style: _normalizeStyle({ borderColor: idea.pinned ? '#BC8809' : undefined })
                  }, [
                    _createElementVNode("div", _hoisted_9, [
                      _createElementVNode("div", _hoisted_10, _toDisplayString(idea.title || "Untitled"), 1),
                      _createElementVNode("button", {
                        onClick: _withModifiers(($event: any) => (togglePin(idea)), ["stop"]),
                        class: _normalizeClass(["text-xs px-2 py-0.5 rounded border", 
                    idea.pinned
                      ? 'border-gold-primary text-gold-primary'
                      : 'border-zinc-700 text-zinc-400'
                  ])
                      }, " Pin ", 10, _hoisted_11)
                    ]),
                    _createElementVNode("div", {
                      class: "text-xs text-gray-400 mt-1 line-clamp-2",
                      innerHTML: idea.contentHtml
                    }, null, 8, _hoisted_12),
                    _createElementVNode("div", _hoisted_13, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(idea.labels || [], (lbl) => {
                        return (_openBlock(), _createElementBlock("span", {
                          key: lbl,
                          class: "text-[10px] px-2 py-0.5 rounded-full border border-zinc-700 text-zinc-300"
                        }, _toDisplayString(lbl), 1))
                      }), 128))
                    ])
                  ], 14, _hoisted_8))
                }), 128))
              ])
            ]),
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("div", _hoisted_15, [
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((ideaTitle).value = $event)),
                  placeholder: "Title — capture the essence",
                  class: "md:col-span-3 px-4 py-3 rounded-xl bg-black-primary border border-zinc-700 placeholder:text-zinc-500"
                }, null, 512), [
                  [_vModelText, ideaTitle.value]
                ]),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((ideaLabels).value = $event)),
                  placeholder: "Labels — growth, product, ops",
                  class: "md:col-span-2 px-4 py-3 rounded-xl bg-black-primary border border-zinc-700 placeholder:text-zinc-500"
                }, null, 512), [
                  [_vModelText, ideaLabels.value]
                ]),
                _createElementVNode("div", _hoisted_16, [
                  _cache[21] || (_cache[21] = _createElementVNode("label", { class: "text-xs text-gray-400" }, "Color", -1)),
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((ideaColor).value = $event)),
                    type: "color",
                    class: "w-10 h-10 rounded border border-zinc-700 bg-black-primary p-0"
                  }, null, 512), [
                    [_vModelText, ideaColor.value]
                  ]),
                  _cache[22] || (_cache[22] = _createElementVNode("label", { class: "text-xs text-gray-400 ml-2" }, "Pinned", -1)),
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((ideaPinned).value = $event)),
                    type: "checkbox",
                    class: "w-4 h-4"
                  }, null, 512), [
                    [_vModelCheckbox, ideaPinned.value]
                  ])
                ])
              ]),
              _createVNode(NoteEditor, {
                modelValue: ideaEditor.value,
                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((ideaEditor).value = $event)),
                placeholder: 'H1, H2, text and bold — keep it sharp'
              }, null, 8, ["modelValue"]),
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("button", {
                  onClick: addIdea,
                  class: "px-4 py-2 rounded-lg bg-gold-primary text-black font-semibold hover:bg-gold-secondary"
                }, " Save as new "),
                _createElementVNode("button", {
                  disabled: !selectedIdea.value,
                  onClick: saveCurrentIdea,
                  class: "px-4 py-2 rounded-lg bg-black-primary text-gold-primary border border-gold-primary disabled:opacity-50"
                }, " Save changes ", 8, _hoisted_18),
                (selectedIdea.value)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      onClick: _cache[10] || (_cache[10] = ($event: any) => (duplicateIdea(selectedIdea.value))),
                      class: "px-4 py-2 rounded-lg bg-black-primary text-zinc-200 border border-zinc-700"
                    }, " Duplicate "))
                  : _createCommentVNode("", true)
              ])
            ])
          ]))
        : (tab.value === 'task')
          ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
              _createElementVNode("div", { class: "mt-3 flex justify-end" }, [
                _createElementVNode("button", {
                  onClick: openNewTaskModal,
                  class: "px-5 py-2.5 rounded-lg bg-gold-primary text-black font-semibold hover:bg-gold-secondary"
                }, " Add Task ")
              ]),
              _createElementVNode("div", _hoisted_20, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(statuses.value, (s) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: s,
                    class: _normalizeClass(["bg-black-secondary rounded-2xl p-3 border border-zinc-800", dragOverStatus.value === s ? 'ring-1 ring-gold-primary' : '']),
                    onDragover: _withModifiers(($event: any) => (onDragOver(s)), ["prevent"]),
                    onDrop: _withModifiers(($event: any) => (onDrop(s)), ["prevent"])
                  }, [
                    _createElementVNode("div", _hoisted_22, [
                      _createElementVNode("h3", _hoisted_23, _toDisplayString(s), 1),
                      _createElementVNode("span", _hoisted_24, _toDisplayString(itemsByStatus.value[s]?.length || 0), 1)
                    ]),
                    _createElementVNode("div", _hoisted_25, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(itemsByStatus.value[s], (item) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: item.id,
                          class: "bg-black-primary/70 rounded-xl border border-zinc-700 p-3 cursor-pointer",
                          draggable: "true",
                          onDragstart: ($event: any) => (onDragStart(item)),
                          onClick: ($event: any) => (openTicket(item))
                        }, [
                          (item.assignees && item.assignees.length)
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 0,
                                class: "flex -space-x-1 mb-2",
                                onClick: _cache[11] || (_cache[11] = _withModifiers(() => {}, ["stop"]))
                              }, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.assignees, (a) => {
                                  return (_openBlock(), _createElementBlock("div", {
                                    key: a.userId || a.email,
                                    class: "inline-flex items-center justify-center rounded-full border border-zinc-700 bg-black-secondary text-[10px] h-6 w-6 text-gold-primary"
                                  }, _toDisplayString(initialsOfAssignee({
                        fullName: a.fullName,
                        email: a.email,
                      })), 1))
                                }), 128))
                              ]))
                            : _createCommentVNode("", true),
                          _createElementVNode("div", _hoisted_27, [
                            _createElementVNode("div", null, [
                              _createElementVNode("div", _hoisted_28, _toDisplayString(item.title), 1),
                              (item.description)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_29, _toDisplayString(item.description), 1))
                                : _createCommentVNode("", true),
                              _createElementVNode("div", _hoisted_30, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.labels || [], (lbl) => {
                                  return (_openBlock(), _createElementBlock("span", {
                                    key: lbl,
                                    class: "text-[10px] px-2 py-0.5 rounded-full border border-gold-primary text-gold-primary"
                                  }, _toDisplayString(lbl), 1))
                                }), 128))
                              ])
                            ]),
                            _cache[23] || (_cache[23] = _createElementVNode("div", { class: "text-right" }, null, -1))
                          ]),
                          _createElementVNode("div", _hoisted_31, [
                            _createElementVNode("div", null, [
                              (item.priority)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_32, "Priority: " + _toDisplayString(item.priority), 1))
                                : _createCommentVNode("", true),
                              (item.dueDate)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_33, "Due: " + _toDisplayString(formatDate(item.dueDate)), 1))
                                : _createCommentVNode("", true)
                            ]),
                            _createElementVNode("div", _hoisted_34, [
                              _createElementVNode("button", {
                                onClick: _withModifiers(($event: any) => (openAssign(item)), ["stop"]),
                                class: "px-2 py-1 rounded-lg border border-zinc-700 text-gray-300 hover:bg-zinc-800"
                              }, " Assign ", 8, _hoisted_35),
                              _createElementVNode("button", {
                                onClick: _withModifiers(($event: any) => (toggleComments(item.id)), ["stop"]),
                                class: "px-2 py-1 rounded-lg border border-zinc-700 text-gray-300 hover:bg-zinc-800"
                              }, "Comments", 8, _hoisted_36)
                            ])
                          ]),
                          (assignOpenFor.value === item.id)
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 1,
                                class: "mt-2 border border-zinc-800 rounded-xl bg-black-secondary p-3",
                                onClick: _cache[12] || (_cache[12] = _withModifiers(() => {}, ["stop"]))
                              }, [
                                _cache[24] || (_cache[24] = _createElementVNode("div", { class: "text-xs text-zinc-400 mb-2" }, " Assign team members ", -1)),
                                _createElementVNode("div", _hoisted_37, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(teamMembers.value, (m) => {
                                    return (_openBlock(), _createElementBlock("label", {
                                      key: m.id,
                                      class: "flex items-center gap-2 cursor-pointer"
                                    }, [
                                      _createElementVNode("input", {
                                        type: "checkbox",
                                        checked: 
                          assigneesSelection.value[item.id]?.has(m.email || '')
                        ,
                                        onChange: ($event: any) => (toggleAssignee(item.id, m.email || ''))
                                      }, null, 40, _hoisted_38),
                                      _createElementVNode("div", _hoisted_39, _toDisplayString(initialsOf(m)), 1),
                                      _createElementVNode("div", _hoisted_40, _toDisplayString(m.fullName || m.email), 1)
                                    ]))
                                  }), 128))
                                ]),
                                _createElementVNode("div", _hoisted_41, [
                                  _createElementVNode("button", {
                                    onClick: cancelAssign,
                                    class: "px-3 py-1.5 rounded-lg border border-zinc-700 text-zinc-300 hover:bg-zinc-800"
                                  }, " Cancel "),
                                  _createElementVNode("button", {
                                    onClick: ($event: any) => (saveAssignees(item)),
                                    class: "px-3 py-1.5 rounded-lg bg-gold-primary text-black border border-gold-secondary"
                                  }, " Save ", 8, _hoisted_42)
                                ])
                              ]))
                            : _createCommentVNode("", true),
                          (commentsOpenFor.value === item.id)
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 2,
                                class: "mt-3 border-t border-zinc-800 pt-3",
                                onClick: _cache[14] || (_cache[14] = _withModifiers(() => {}, ["stop"]))
                              }, [
                                (commentsLoading.value)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_43, " Loading comments... "))
                                  : (_openBlock(), _createElementBlock("div", _hoisted_44, [
                                      (!comments.value.length)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_45, " No comments yet. "))
                                        : (_openBlock(), _createElementBlock("div", _hoisted_46, [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(comments.value, (c) => {
                                              return (_openBlock(), _createElementBlock("div", {
                                                key: c.id,
                                                class: "text-sm"
                                              }, [
                                                _createElementVNode("div", _hoisted_47, _toDisplayString(c.message), 1),
                                                _createElementVNode("div", _hoisted_48, " — " + _toDisplayString(c.author || "unknown"), 1)
                                              ]))
                                            }), 128))
                                          ]))
                                    ])),
                                _createElementVNode("div", _hoisted_49, [
                                  _withDirectives(_createElementVNode("input", {
                                    "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((newComment).value = $event)),
                                    placeholder: "Write a comment",
                                    class: "flex-1 px-3 py-2 rounded bg-black-primary border border-zinc-700"
                                  }, null, 512), [
                                    [_vModelText, newComment.value]
                                  ]),
                                  _createElementVNode("button", {
                                    onClick: ($event: any) => (submitComment(item.id)),
                                    class: "px-3 py-2 rounded bg-gold-primary text-black"
                                  }, " Send ", 8, _hoisted_50)
                                ])
                              ]))
                            : _createCommentVNode("", true)
                        ], 40, _hoisted_26))
                      }), 128))
                    ])
                  ], 42, _hoisted_21))
                }), 128))
              ])
            ]))
          : (tab.value === 'kpi')
            ? (_openBlock(), _createElementBlock("div", _hoisted_51, [
                _createVNode(KPIsDashboard)
              ]))
            : _createCommentVNode("", true),
      (showAddTaskModal.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_52, [
            _createElementVNode("div", {
              class: "absolute inset-0 bg-black/30 backdrop-blur-lg backdrop-saturate-150",
              onClick: closeNewTaskModal
            }),
            _createElementVNode("div", _hoisted_53, [
              _createElementVNode("div", { class: "p-4 border-b border-zinc-800 flex items-center justify-between" }, [
                _cache[25] || (_cache[25] = _createElementVNode("div", { class: "text-2xl font-semibold text-gold-primary" }, "New Task", -1)),
                _createElementVNode("button", {
                  onClick: closeNewTaskModal,
                  class: "px-3 py-1.5 rounded-lg border border-zinc-700 text-zinc-300 hover:bg-zinc-800"
                }, "Close")
              ]),
              _createElementVNode("div", _hoisted_54, [
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((newTaskTitle).value = $event)),
                  placeholder: "Task — write a clear, actionable title",
                  class: "w-full px-4 py-3 rounded-xl bg-black-primary border border-zinc-700 placeholder:text-zinc-500"
                }, null, 512), [
                  [_vModelText, newTaskTitle.value]
                ]),
                _withDirectives(_createElementVNode("textarea", {
                  "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((newTaskDescription).value = $event)),
                  placeholder: "Details — acceptance criteria, links",
                  class: "w-full px-4 py-3 rounded-xl bg-black-primary border border-zinc-700 placeholder:text-zinc-500 min-h-[120px]"
                }, null, 512), [
                  [_vModelText, newTaskDescription.value]
                ]),
                _createElementVNode("div", _hoisted_55, [
                  _withDirectives(_createElementVNode("select", {
                    "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((newTaskPriority).value = $event)),
                    class: "px-4 py-3 rounded-xl bg-black-primary border border-zinc-700 text-zinc-200"
                  }, _cache[26] || (_cache[26] = [
                    _createElementVNode("option", null, "Low", -1),
                    _createElementVNode("option", null, "Medium", -1),
                    _createElementVNode("option", null, "High", -1),
                    _createElementVNode("option", null, "Urgent", -1)
                  ]), 512), [
                    [_vModelSelect, newTaskPriority.value]
                  ]),
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((newTaskDueDate).value = $event)),
                    type: "date",
                    class: "px-4 py-3 rounded-xl bg-black-primary border border-zinc-700 text-zinc-200"
                  }, null, 512), [
                    [_vModelText, newTaskDueDate.value]
                  ]),
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((newTaskLabels).value = $event)),
                    placeholder: "Labels — performance, seo, ops",
                    class: "px-4 py-3 rounded-xl bg-black-primary border border-zinc-700 placeholder:text-zinc-500"
                  }, null, 512), [
                    [_vModelText, newTaskLabels.value]
                  ])
                ]),
                (newTaskError.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_56, _toDisplayString(newTaskError.value), 1))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_57, [
                  _createElementVNode("button", {
                    disabled: isCreatingTask.value,
                    onClick: submitNewTask,
                    class: "px-5 py-2.5 rounded-lg bg-gold-primary text-black font-semibold hover:bg-gold-secondary disabled:opacity-50 disabled:cursor-not-allowed"
                  }, "Create Task", 8, _hoisted_58)
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      (showTicketModal.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_59, [
            _createElementVNode("div", {
              class: "absolute inset-0 bg-black/30 backdrop-blur-lg backdrop-saturate-150",
              onClick: closeTicket
            }),
            _createElementVNode("div", _hoisted_60, [
              _createElementVNode("div", _hoisted_61, [
                _createElementVNode("div", null, [
                  _cache[27] || (_cache[27] = _createElementVNode("div", { class: "text-xs uppercase tracking-wide text-zinc-400" }, " Ticket ", -1)),
                  _createElementVNode("div", _hoisted_62, _toDisplayString(activeTicket.value?.title), 1)
                ]),
                _createElementVNode("button", {
                  onClick: closeTicket,
                  class: "px-3 py-1.5 rounded-lg border border-zinc-700 text-zinc-300 hover:bg-zinc-800"
                }, " Close ")
              ]),
              _createElementVNode("div", _hoisted_63, [
                _createElementVNode("div", _hoisted_64, [
                  _createElementVNode("div", null, [
                    _cache[28] || (_cache[28] = _createElementVNode("div", { class: "text-xs text-zinc-400 mb-1" }, "Details", -1)),
                    _createElementVNode("div", _hoisted_65, [
                      _createElementVNode("div", _hoisted_66, _toDisplayString(activeTicket.value?.description || "No description."), 1)
                    ])
                  ]),
                  _createElementVNode("div", null, [
                    _cache[29] || (_cache[29] = _createElementVNode("div", { class: "text-xs text-zinc-400 mb-1" }, "Comments", -1)),
                    _createElementVNode("div", _hoisted_67, [
                      (activeTicketCommentsLoading.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_68, " Loading comments… "))
                        : (_openBlock(), _createElementBlock("div", _hoisted_69, [
                            (!activeTicketComments.value.length)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_70, " No comments yet. "))
                              : (_openBlock(), _createElementBlock("div", _hoisted_71, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(activeTicketComments.value, (c) => {
                                    return (_openBlock(), _createElementBlock("div", {
                                      key: c.id,
                                      class: "text-sm"
                                    }, [
                                      _createElementVNode("div", _hoisted_72, _toDisplayString(c.message), 1),
                                      _createElementVNode("div", _hoisted_73, " — " + _toDisplayString(c.author || "unknown"), 1)
                                    ]))
                                  }), 128))
                                ])),
                            _createElementVNode("div", _hoisted_74, [
                              _withDirectives(_createElementVNode("input", {
                                "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((newTicketComment).value = $event)),
                                placeholder: "Write a comment",
                                class: "flex-1 px-3 py-2 rounded bg-black-primary border border-zinc-700"
                              }, null, 512), [
                                [_vModelText, newTicketComment.value]
                              ]),
                              _createElementVNode("button", {
                                onClick: submitTicketComment,
                                class: "px-3 py-2 rounded bg-gold-primary text-black"
                              }, " Send ")
                            ])
                          ]))
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_75, [
                  _createElementVNode("div", _hoisted_76, [
                    _cache[30] || (_cache[30] = _createElementVNode("div", { class: "text-xs text-zinc-400" }, "Status", -1)),
                    _createElementVNode("div", _hoisted_77, _toDisplayString(activeTicket.value?.status), 1)
                  ]),
                  _createElementVNode("div", _hoisted_78, [
                    _cache[31] || (_cache[31] = _createElementVNode("div", { class: "text-xs text-zinc-400" }, "Priority", -1)),
                    _createElementVNode("div", _hoisted_79, _toDisplayString(activeTicket.value?.priority || "—"), 1)
                  ]),
                  _createElementVNode("div", _hoisted_80, [
                    _cache[32] || (_cache[32] = _createElementVNode("div", { class: "text-xs text-zinc-400" }, "Due Date", -1)),
                    _createElementVNode("div", _hoisted_81, _toDisplayString(activeTicket.value?.dueDate
                      ? formatDate(activeTicket.value?.dueDate as any)
                      : "—"), 1)
                  ]),
                  _createElementVNode("div", _hoisted_82, [
                    _cache[33] || (_cache[33] = _createElementVNode("div", { class: "text-xs text-zinc-400" }, "Labels", -1)),
                    _createElementVNode("div", _hoisted_83, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(activeTicket.value?.labels || [], (lbl) => {
                        return (_openBlock(), _createElementBlock("span", {
                          key: lbl,
                          class: "text-[10px] px-2 py-0.5 rounded-full border border-gold-primary text-gold-primary"
                        }, _toDisplayString(lbl), 1))
                      }), 128))
                    ])
                  ])
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})